import { FC, JSX } from 'react';
import { useFormContext } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';

import { ContentStyles } from '@/entities/content/api/types';

import { SwitchSetting } from '../Settings';

interface Props {}

const ControlsSettings: FC<Props> = (): JSX.Element => {
  const formMethods = useFormContext<ContentStyles>();
  const { watch } = formMethods;
  const showButtons = watch('config.controls.enabled');
  const contentType = watch('type');

  return (
    <div className="flex flex-col gap-2">
      <SwitchSetting
        title="Controls"
        name="config.controls.enabled"
        type="group"
      />

      <div
        className={twMerge(
          'flex flex-col gap-1 rounded-lg bg-black/[.02] p-3 dark:bg-white/[.02]',
          showButtons ? '' : 'hidden'
        )}
      >
        {contentType === 'video' && (
          <>
            <SwitchSetting
              title="Play button"
              type="inline"
              name="config.controls.play_button"
            />
            <SwitchSetting
              title="Progress bar"
              type="inline"
              name="config.controls.progress_bar"
            />
            <SwitchSetting
              title="Fullscreen button"
              type="inline"
              name="config.controls.fullscreen_button"
            />
            <SwitchSetting
              title="Mute button"
              type="inline"
              name="config.controls.mute_button"
            />
          </>
        )}

        {contentType === 'slider' && (
          <>
            <SwitchSetting
              title="Progress bar"
              type="inline"
              name="config.controls.progress_bar"
            />
            <SwitchSetting
              title="Navigation buttons"
              type="inline"
              name="config.controls.navigation_buttons"
            />
          </>
        )}
      </div>
    </div>
  );
};

export default ControlsSettings;
